
/**
 * @component FormTextArea
 *
 * @public
 */
export default {
  name: 'FormTextArea',
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 250,
    },
  },
  methods: {

    /**
     * Emit input event.
     *
     * @private
     */

    update(e) {
      this.$emit('input', e.target.value, e);
    },

    /**
     * Emit keydown event.
     *
     * @private
     */

    keydown(e) {
      this.$emit('keydown', e.keyCode, e);
    },

    /**
     * Emit blur event.
     *
     * @private
     */

    blur(e) {
      this.$emit('blur', e.target.value, e);
    },
  },
};
